<template>
  <OverlayElement :visible="loadingStore.loading">
    <PhCircleNotch class="overlay__icon spinner" />
  </OverlayElement>
</template>

<script setup lang="ts">
import { PhCircleNotch } from '@phosphor-icons/vue'
import { useLoadingStore } from '@/stores/loading.ts'
import OverlayElement from '@/components/OverlayElement.vue'

const loadingStore = useLoadingStore()
</script>
